import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteHallPayload } from '@app-store/slices/hall/delete'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IDeleteHallPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.hall.delete

function* deleteHallSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.delete(`/meeting/hall/${payload.hallId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Hall deleted successfully.'
            })
            yield payload.sagaCB?.onSuccess()
        } else {
            yield payload.sagaCB?.onError()
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload.sagaCB?.onError()
    }
}

function* deleteHallSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteHallSagaTask)
}

export default deleteHallSaga
